export default {"src":"__ASTRO_ASSET_IMAGE__B7ZK8JoG__","width":236,"height":256,"format":"webp"}